import { polarToXY } from '@circle/shared';
import type { Fragment, TodayCtx } from '../types';
import { n, svgEl } from '../../core/svg';
import { metricsAt, W } from './metrics';

/** Bead, halo and hub radii at the full ring size; scaled with it. */
const BEAD = 9;
const HALO = 22;
const HUB = 4;

/** A clock hand from near the centre out past the ring, with a bead on the ring. */
export const todayFragment: Fragment<TodayCtx> = (ctx, state) => {
  const M = metricsAt(ctx.radius);
  const k = ctx.radius > 0 ? ctx.radius / M.ring : 1;
  const inner = polarToXY(ctx.angle, M.todayInner);
  const outer = polarToXY(ctx.angle, M.todayOuter);
  const bead = polarToXY(ctx.angle, M.ring);

  const g = svgEl('g', { 'data-frag': 'today', 'pointer-events': 'none' });

  g.append(
    svgEl('line', {
      x1: n(inner.x),
      y1: n(inner.y),
      x2: n(outer.x),
      y2: n(outer.y),
      stroke: 'var(--today)',
      'stroke-width': W.today,
      'stroke-linecap': 'round',
      'vector-effect': 'non-scaling-stroke',
      opacity: state.hover ? 0.95 : 0.6,
    }),
  );
  g.append(
    svgEl('circle', {
      cx: n(bead.x),
      cy: n(bead.y),
      r: n(BEAD * k),
      fill: 'var(--today)',
    }),
  );
  g.append(
    svgEl('circle', {
      cx: n(bead.x),
      cy: n(bead.y),
      r: n(HALO * k),
      fill: 'none',
      stroke: 'var(--today)',
      'stroke-width': W.hairline,
      'vector-effect': 'non-scaling-stroke',
      opacity: 0.5,
    }),
  );
  g.append(svgEl('circle', { cx: 0, cy: 0, r: n(HUB * k), fill: 'var(--today)', opacity: 0.5 }));

  return g;
};
